import GET_BEST_OF_RING_VIDEO_BY_ID from '@amzn/ring-neighbors-contentful-gql-schema/operations/best-of-ring/getBestOfRingVideoById.graphql';
import { useContentfulQuery } from 'src/hooks/useContentfulQuery';
import type {
  BestOfRingVideo,
  GetBestOfRingVideoByIdQuery,
} from '@amzn/ring-neighbors-contentful-gql-schema';

export const useGetBestOfRingVideoById = (id: string) => {
  const { data, ...rest } = useContentfulQuery<GetBestOfRingVideoByIdQuery>(
    GET_BEST_OF_RING_VIDEO_BY_ID,
    {
      variables: { id },
    },
  );

  return {
    ...rest,
    data: data?.bestOfRingVideo as BestOfRingVideo,
  };
};
